var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsBoolean, IsDate, IsHexColor, IsIn, IsInt, IsNumber, IsOptional, IsString, Max, Min, } from 'class-validator';
import { LinkDescriptorDto } from '../shared.js';
const PAYMENT_METHOD_VALUES = ['none', 'post_payment', 'pre_payment'];
export class UpdateMarkingFormDataInputDto extends LinkDescriptorDto {
    payment_method;
    deleted_date;
    publish_date;
    ord_contragent_id;
    draft_contract_id;
    custom_contract_id;
    draft_act_id;
    custom_act_id;
    final_act_id;
    final_contract_id;
    invoice_id;
    account_details;
    vat_percent;
    publish_option_flag;
    publisher_flag;
    duration;
    contract_flag;
    invoice_flag;
    creative_flag;
    act_flag;
    contract_edo_flag;
    act_edo_flag;
    mark_text;
    mark_media;
    mark_media_color;
    mark_media_text;
    // Расширенные поля для редактора маркировки на медиа (SYN-829)
    mark_media_font_size;
    mark_media_alignment;
    mark_media_font_family;
    mark_media_has_background;
    mark_media_background_color;
    mark_media_position_x;
    mark_media_position_y;
    // Информация о масштабе для пересчета шрифта и позиций при экспорте
    mark_media_canvas_width;
    mark_media_canvas_height;
    mark_media_original_width;
    mark_media_original_height;
    // Кастомные цвета для палитры (максимум 4 цвета)
    // Строка с разделителем запятой: "#FF0000FF,#00FF00FF,#0000FFFF,#FFFFFFFF"
    mark_media_custom_text_colors;
    mark_media_custom_background_colors;
}
__decorate([
    IsOptional(),
    IsIn(PAYMENT_METHOD_VALUES),
    __metadata("design:type", Object)
], UpdateMarkingFormDataInputDto.prototype, "payment_method", void 0);
__decorate([
    IsOptional(),
    IsDate(),
    Type(() => Date),
    __metadata("design:type", Object)
], UpdateMarkingFormDataInputDto.prototype, "deleted_date", void 0);
__decorate([
    IsOptional(),
    IsDate(),
    __metadata("design:type", Date)
], UpdateMarkingFormDataInputDto.prototype, "publish_date", void 0);
__decorate([
    IsOptional(),
    Min(1),
    IsInt(),
    __metadata("design:type", Object)
], UpdateMarkingFormDataInputDto.prototype, "ord_contragent_id", void 0);
__decorate([
    IsOptional(),
    Min(1),
    IsInt(),
    __metadata("design:type", Object)
], UpdateMarkingFormDataInputDto.prototype, "draft_contract_id", void 0);
__decorate([
    IsOptional(),
    Min(1),
    IsInt(),
    __metadata("design:type", Object)
], UpdateMarkingFormDataInputDto.prototype, "custom_contract_id", void 0);
__decorate([
    IsOptional(),
    Min(1),
    IsInt(),
    __metadata("design:type", Object)
], UpdateMarkingFormDataInputDto.prototype, "draft_act_id", void 0);
__decorate([
    IsOptional(),
    Min(1),
    IsInt(),
    __metadata("design:type", Object)
], UpdateMarkingFormDataInputDto.prototype, "custom_act_id", void 0);
__decorate([
    IsOptional(),
    Min(1),
    IsInt(),
    __metadata("design:type", Object)
], UpdateMarkingFormDataInputDto.prototype, "final_act_id", void 0);
__decorate([
    IsOptional(),
    Min(1),
    IsInt(),
    __metadata("design:type", Object)
], UpdateMarkingFormDataInputDto.prototype, "final_contract_id", void 0);
__decorate([
    IsOptional(),
    Min(1),
    IsInt(),
    __metadata("design:type", Object)
], UpdateMarkingFormDataInputDto.prototype, "invoice_id", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateMarkingFormDataInputDto.prototype, "account_details", void 0);
__decorate([
    IsOptional(),
    IsNumber({
        allowNaN: false,
        allowInfinity: false,
    }),
    Min(-1),
    Max(22),
    __metadata("design:type", Number)
], UpdateMarkingFormDataInputDto.prototype, "vat_percent", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateMarkingFormDataInputDto.prototype, "publish_option_flag", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateMarkingFormDataInputDto.prototype, "publisher_flag", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateMarkingFormDataInputDto.prototype, "duration", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateMarkingFormDataInputDto.prototype, "contract_flag", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateMarkingFormDataInputDto.prototype, "invoice_flag", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateMarkingFormDataInputDto.prototype, "creative_flag", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateMarkingFormDataInputDto.prototype, "act_flag", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateMarkingFormDataInputDto.prototype, "contract_edo_flag", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateMarkingFormDataInputDto.prototype, "act_edo_flag", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateMarkingFormDataInputDto.prototype, "mark_text", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateMarkingFormDataInputDto.prototype, "mark_media", void 0);
__decorate([
    IsOptional(),
    IsHexColor(),
    __metadata("design:type", String)
], UpdateMarkingFormDataInputDto.prototype, "mark_media_color", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateMarkingFormDataInputDto.prototype, "mark_media_text", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    Min(4),
    Max(18),
    __metadata("design:type", Number)
], UpdateMarkingFormDataInputDto.prototype, "mark_media_font_size", void 0);
__decorate([
    IsOptional(),
    IsIn(['left', 'center', 'right']),
    __metadata("design:type", String)
], UpdateMarkingFormDataInputDto.prototype, "mark_media_alignment", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateMarkingFormDataInputDto.prototype, "mark_media_font_family", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateMarkingFormDataInputDto.prototype, "mark_media_has_background", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], UpdateMarkingFormDataInputDto.prototype, "mark_media_background_color", void 0);
__decorate([
    IsOptional(),
    IsNumber({ allowNaN: false, allowInfinity: false }),
    Min(0),
    Max(100),
    __metadata("design:type", Number)
], UpdateMarkingFormDataInputDto.prototype, "mark_media_position_x", void 0);
__decorate([
    IsOptional(),
    IsNumber({ allowNaN: false, allowInfinity: false }),
    Min(0),
    Max(100),
    __metadata("design:type", Number)
], UpdateMarkingFormDataInputDto.prototype, "mark_media_position_y", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    Min(1),
    __metadata("design:type", Number)
], UpdateMarkingFormDataInputDto.prototype, "mark_media_canvas_width", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    Min(1),
    __metadata("design:type", Number)
], UpdateMarkingFormDataInputDto.prototype, "mark_media_canvas_height", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    Min(1),
    __metadata("design:type", Number)
], UpdateMarkingFormDataInputDto.prototype, "mark_media_original_width", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    Min(1),
    __metadata("design:type", Number)
], UpdateMarkingFormDataInputDto.prototype, "mark_media_original_height", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateMarkingFormDataInputDto.prototype, "mark_media_custom_text_colors", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UpdateMarkingFormDataInputDto.prototype, "mark_media_custom_background_colors", void 0);
//# sourceMappingURL=marking-form.js.map